"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const More_svg_1 = __importDefault(require("./More.svg"));
/**
 * Standard more options navigation icon
 * See: https://www.figma.com/file/UpS0VG7yUnr0VLopn0wBwx/Sharing-component?node-id=5785%3A13753
 */
function MoreIcon() {
    return (0, jsx_runtime_1.jsx)(More_svg_1.default, {});
}
exports.MoreIcon = MoreIcon;
//# sourceMappingURL=MoreIcon.js.map